import React, { Component } from "react";
import { MDBIcon } from 'mdbreact';
import { SeccionPMaestroCoopVirtual_ } from '../../services/WebAPI_Utrahuilca';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { URLImgFront } from '../../config/URLDB';

class ServiciosVirtuales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            PerNatJur: [],
            stateImg: false
        };
    }

    async componentDidMount() {

        AOS.init({
            duration: 1000,
            easing: 'ease-in-out',
            once: false,
        });

        this.ConsumeData(1);
    }

    ConsumeData = async (id) => {
        this.setState({ PerNatJur: [] });

        const data = {
            tran: 7,
            idmaestrocoopv: 0,
            idtipopers: id,
            titulo: 'NA',
            rutaiconotit: 'NA',
            descripcion: 'NA',
            estado: 1,
            idusucrea: 0
        };

        try {
            const response = await SeccionPMaestroCoopVirtual_(data);

            if (response.data.length > 0) {
                this.setState({
                    PerNatJur: response.data,
                    stateImg: true
                });
            } else {
                this.setState({ stateImg: false });
            }
        } catch (error) {
            console.error("Error al consumir datos:", error);
        }
    };

    render() {
        return (
            <React.Fragment>
                <div className="bg-white" style={{ width: '100%' }}>
                    <div className="py-5">

                        <div style={{ width: '100%' }}>
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: '40px 20px',
                                width: '100%',
                                background: 'rgb(247, 247, 247)',
                            }}>
                                <div style={{ maxWidth: '100%', marginRight: '10px', paddingBlockEnd: '25px' }}>
                                    <h2 className="fs-1 fs-sm-1 fs-md-2 fs-lg-3 fw-bold text-center text-md-start" data-aos="fade-down-right" style={{ fontWeight: 'bold', marginBottom: '20px' }}>
                                        Cooperativa Virtual
                                    </h2>

                                    <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', justifyContent: 'center' }}>
                                        <div style={{ height: '4px', backgroundColor: 'rgb(240, 127, 0)', borderRadius: '2px', width: '60px' }}></div>
                                        <div style={{ height: '4px', backgroundColor: 'rgb(240, 127, 0)', borderRadius: '2px', width: '30px' }}></div>
                                    </div>

                                    {this.state.PerNatJur.length > 0 ? (
                                        <ul  style={{ listStyleType: 'none', padding: 0, marginBottom: '30px' }}>
                                            {this.state.PerNatJur.map((item, index) => (
                                                <li data-aos="fade-down-right" key={item.id || index} style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                                    <MDBIcon icon="check-circle" style={{ color: 'rgb(240, 127, 0)', marginRight: '10px' }} />
                                                    <span style={{ fontSize: '16px' }}>{item.titulo}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p style={{ fontStyle: 'italic' }}>Cargando servicios...</p>
                                    )}

                                    <Link  to="/Cooperativa_Virtual">
                                        <span data-aos="fade-down"
                                            className="px-4 py-2 mt-3 d-inline-block"
                                            style={{
                                                background: 'rgb(240, 127, 0)',
                                                color: 'white',
                                                fontWeight: 'bold',
                                                borderRadius: '20px',
                                                cursor: 'pointer',
                                            }}>
                                            Conozca más</span>
                                    </Link>
                                </div>

                                <div data-aos="zoom-out" style={{
                                    overflow: 'hidden',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    maxHeight: '80vh'
                                }}>
                                    <img
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            maxWidth: '600px',
                                            maxHeight: '100%',
                                            objectFit: 'contain',
                                        }}
                                        className="img-fluid"
                                        src={`${URLImgFront}/assets/Secc - Transaccional/ImagenTexto/pc-coop-virtual.webp`}
                                        alt="Laptop Cooperativa Virtual"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ServiciosVirtuales;